import { FC } from "react";

export const AuthLayout: FC = ({ children }) => {
  return <>{children}</>;
};
